export default "/_next/static/images/75303af93af03c29e768ac385e89b2b4.jpg";